module.exports = __webpack_public_path__ + "static/logo_booking-3942169f75e26acb56e13ad295af4c80.png";